import React from 'react';
import scanIcon from 'images/barcode.png';
import Button from 'screens/components/basic/Button';
import TextInput from 'screens/components/basic/TextInput';
import ReadBarcode from 'library/readBarcode';
import { connect } from 'react-redux';
import { formInput } from 'actions/FormActions';

class ProductManualUPC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showInput: false
    };
    this.barcode = new ReadBarcode();
  }

  componentDidMount = () => {
    window.addEventListener("keypress", this.barcodeListener);
  };

  componentWillUnmount = () => {
    window.removeEventListener("keypress", this.barcodeListener);
  };

  showInputText = () => {
    this.setState({ showInput: true });
  };

  barcodeListener = () => {
    this.barcode.listening(this.setUpc)
  }

  setUpc = (upc) => {
    this.props.formInput(upc, "ManualUPCNumber")
  }

  render() {
    const { manualUPCValue } = this.props
    return (
      <div>
        <div className="text-center">
          <h2 className="col-lg-12 pb-2">Scan UPC, USE PER CAUTION!</h2>
          <h5 style={{ paddingBottom: "20px", color: "red" }}>We currently support only UPC. Please scan accordingly!</h5>
          <div className="img_centered">
            <img src={scanIcon} />
          </div>
          <h3>{this.state.upc}</h3>
          {
            (!this.state.upc) ? <Button type="FlatButtonPrimary" label={`Input UPC`} secondary={false} onTouchTap={this.showInputText} /> : ''
          }
          {
            (this.state.showInput)
              ? <div className="centered pb-5">
                <TextInput
                  name={'ManualUPCNumber'}
                  hintText={`UPC Number`}
                  fullWidth={true}
                  className="input-center"
                  label={`UPC Number`}
                />
              </div> : ''
          }
          {
            manualUPCValue ? <h3>{manualUPCValue}</h3> : ""
          }
        </div>

        <div style={{ marginTop: 12 }}>
          <Button
            className="pull-right"
            variant="contained"
            color="primary"
            onTouchTap={this.props.cancel}
            sx={{ float: 'right', marginRight: 2 }}
          >
            Confirm
          </Button>
          <Button
            variant="text"
            onTouchTap={this.props.cancel}
            sx={{ marginRight: 12 }}
            style={{ float: 'right' }}
            className="pull-right"
          >
            Cancel
          </Button>
        </div>
      </div>
    );
  }
}

function mapStatetoProps(state) {
  return {
    manualUPCValue: state.form.ManualUPCNumber || ""
  };
}

function mapDispatchToProps(dispatch) {
  return {
    formInput: (value, name) => dispatch(formInput(value, name))
  };
}

export default connect(mapStatetoProps, mapDispatchToProps)(ProductManualUPC);
